import { c as _c } from "react/compiler-runtime";
import { Box, BoxProps, Button, ButtonProps, Heading, Stack, Text, VStack } from '@chakra-ui/react';
import { ButtonStack } from '@src/components/sco/ButtonStack';
import { ChevronRightIcon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import NextLink, { LinkProps } from 'next/link';
import React, { ReactNode } from 'react';
export const ContentSection: React.FC<{
  buttons?: Array<ButtonProps & LinkProps>;
  component?: ReactNode | ReactNode[];
  componentBoxProps?: BoxProps;
  componentPlacement?: 'left' | 'right';
  copyBoxProps?: BoxProps;
  description?: ReactNode;
  title?: ReactNode;
}> = props => {
  const $ = _c(32);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([10, 10, 10, 10, 20]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = props.componentPlacement === "right" ? "row" : "row-reverse";
  let t2;
  if ($[2] !== getBreakpointValue || $[3] !== t1) {
    t2 = getBreakpointValue(["column-reverse", "column-reverse", "column-reverse", t1]);
    $[2] = getBreakpointValue;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== getBreakpointValue) {
    t3 = getBreakpointValue([null, null, "80%", null]);
    $[5] = getBreakpointValue;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["2xl", "2xl", "2xl", "3xl"];
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props.title) {
    t5 = <Heading fontSize={t4} lineHeight="normal">{props.title}</Heading>;
    $[8] = props.title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = ["lg", "lg", "lg", "xl"];
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== props.description) {
    t7 = <Text color="colorPalette.fg" fontFamily="longform" fontSize={t6}>{props.description}</Text>;
    $[11] = props.description;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== props.buttons) {
    t8 = props.buttons && <ButtonStack stackProps={{
      paddingTop: 2,
      justify: "flex-start",
      width: "full"
    }}>{props.buttons.map(_temp)}</ButtonStack>;
    $[13] = props.buttons;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== props.copyBoxProps || $[16] !== t3 || $[17] !== t5 || $[18] !== t7 || $[19] !== t8) {
    t9 = <VStack align="stretch" flex={1} gap={4} justify="center" maxWidth={t3} {...props.copyBoxProps}>{t5}{t7}{t8}</VStack>;
    $[15] = props.copyBoxProps;
    $[16] = t3;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== getBreakpointValue) {
    t10 = getBreakpointValue([null, null, "80%", null]);
    $[21] = getBreakpointValue;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== props.component || $[24] !== props.componentBoxProps || $[25] !== t10) {
    t11 = <Box flex={1.25} maxWidth={t10} width="100%" {...props.componentBoxProps}>{props.component}</Box>;
    $[23] = props.component;
    $[24] = props.componentBoxProps;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t0 || $[28] !== t11 || $[29] !== t2 || $[30] !== t9) {
    t12 = <Stack align="center" gap={t0} direction={t2}>{t9}{t11}</Stack>;
    $[27] = t0;
    $[28] = t11;
    $[29] = t2;
    $[30] = t9;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
};
function _temp(button, idx) {
  return <Button size="lg" {...button} asChild={true}><NextLink key={idx} href="/investors/matching/start">{button.title || button.children}<ChevronRightIcon /></NextLink></Button>;
}